import React from 'react'

function Index1() {
    return (
        <>
            <div>
                {/* header-area */}
                <header id="header">
                    <div id="sticky-header" className="menu-area menu-style-two transparent-header">
                        <div className="container custom-container-three">
                            <div className="row">
                                <div className="col-12">
                                    <div className="mobile-nav-toggler"><i className="fas fa-bars" /></div>
                                    <div className="menu-wrap">
                                        <nav className="menu-nav">
                                            <div className="logo">
                                                <a href="/"><img src="assets/img/logo/logo.png" alt /></a>
                                            </div>
                                            <div className="navbar-wrap main-menu d-none d-lg-flex">
                                                <ul className="navigation">
                                                    <li className="active menu-item-has-children"><a href="#header" className="section-link">Home</a>
                                                        <ul className="sub-menu">
                                                            <li><a href="/">Home One</a></li>
                                                            <li className="active"><a href="/index">Home Two</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a href="#about" className="section-link">About us</a></li>
                                                    <li><a href="#roadmap" className="section-link">Roadmap</a></li>
                                                    <li><a href="#faq" className="section-link">Faq</a></li>
                                                    <li className="menu-item-has-children"><a href="/blog">Blog</a>
                                                        <ul className="sub-menu">
                                                            <li><a href="/blog">Our Blog</a></li>
                                                            <li><a href="/blog-details">Blog Details</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a href="#contact" className="section-link">Contact us</a></li>
                                                </ul>
                                            </div>
                                            <div className="header-action d-none d-md-block">
                                                <ul>
                                                    <li className="header-lang"><span className="selected-lang">ENG</span>
                                                        <ul className="lang-list">
                                                            <li><a href="#">IND</a></li>
                                                            <li><a href="#">BNG</a></li>
                                                            <li><a href="#">TUR</a></li>
                                                            <li><a href="#">CIN</a></li>
                                                        </ul>
                                                    </li>
                                                    <li className="header-btn"><a href="#" className="btn">Buy Now</a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                    {/* Mobile Menu  */}
                                    <div className="mobile-menu">
                                        <nav className="menu-box">
                                            <div className="close-btn"><i className="fas fa-times" /></div>
                                            <div className="nav-logo"><a href="/"><img src="assets/img/logo/logo.png" alt title /></a>
                                            </div>
                                            <div className="menu-outer">
                                                {/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}
                                            </div>
                                            <div className="social-links">
                                                <ul className="clearfix">
                                                    <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                                                    <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                    <li><a href="#"><i className="fab fa-instagram" /></a></li>
                                                    <li><a href="#"><i className="fab fa-linkedin-in" /></a></li>
                                                    <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                    <div className="menu-backdrop" />
                                    {/* End Mobile Menu */}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                {/* header-area-end */}
                {/* main-area */}
                <main>
                    {/* banner-area */}
                    <section className="banner-area-two">
                        <div className="banner-bg-two" />
                        <div className="container custom-container-four">
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <div className="banner-content text-center">
                                        <h2 className="title wow fadeInDown" data-wow-delay=".2s">World’s Biggest ICO Cryptocurrency Platform for you</h2>
                                        <img src="assets/img/banner/banner_img.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="banner-social-wrap">
                            <ul>
                                <li><a href="#" className="banner-social-link"><i className="fab fa-linkedin-in" /></a><span>LinkedIn</span></li>
                                <li><a href="#" className="banner-social-link"><i className="fab fa-twitter" /></a><span>Twitter</span></li>
                                <li><a href="#" className="banner-social-link"><i className="fab fa-pinterest" /></a><span>Pinterest</span></li>
                                <li><a href="#" className="banner-social-link"><i className="fab fa-instagram" /></a><span>Instagram</span></li>
                            </ul>
                        </div>
                        <div className="banner-scroll">
                            <span>Scroll down</span>
                            <a href="#" data-target="#about"><img src="assets/img/icon/scroll_icon.svg" alt /></a>
                        </div>
                    </section>
                    {/* banner-area-end */}
                    {/* countdown-area */}
                    <section id="countdown" className="countdown-area-two">
                        <div className="container custom-container-four">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="countdown-wrap">
                                        <h2 className="title">ICO Will Start In..</h2>
                                        <div id="countdown-gampang" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* countdown-area-end */}
                    {/* about-area */}
                    <section id="about" className="about-area-two">
                        <div className="container custom-container-four">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <div className="about-img-two text-center wow fadeInLeft" data-wow-delay=".2s">
                                        <img src="assets/img/images/h2_about_img.png" alt />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-content-two wow fadeInRight" data-wow-delay=".2s">
                                        <div className="section-title section-title-two mb-15">
                                            <span className="sub-title">ABOUT Crypto ICO</span>
                                            <h2 className="title">Bigtech Theme is the best for your ICO</h2>
                                        </div>
                                        <p>The World’s 1st ICO Platform That Offers Rewards and The platform helps investors to make easy</p>
                                        <div className="about-list">
                                            <ul>
                                                <li><i className="fas fa-check" />Mouthwatering leading how real formula also</li>
                                                <li><i className="fas fa-check" />Locked-in have can mountain thought</li>
                                            </ul>
                                        </div>
                                        <a href="assets/img/images/h2_about_img.png" download target="_blank" className="btn btn-two">Download Document</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="about-shape-wrap">
                            <img src="assets/img/images/about_shape01.png" alt className="shape-one" />
                            <img src="assets/img/images/about_shape02.png" alt className="shape-two rotateme" />
                        </div>
                    </section>
                    {/* about-area-end */}
                    {/* choose-area */}
                    <section className="choose-area-two choose-bg pb-130">
                        <div className="container custom-container-four">
                            <div className="row justify-content-center">
                                <div className="col-lg-6">
                                    <div className="section-title text-center mb-70">
                                        <span className="sub-title">why Choose us</span>
                                        <h2 className="title">Why you choose our bigtech Token</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-sm-6">
                                    <div className="choose-item-two wow fadeInUp" data-wow-delay=".2s">
                                        <div className="choose-icon-two">
                                            <img src="assets/img/icon/h2_choose_icon01.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Mobile payment make easy</a></h2>
                                            <p>Add new, trending and rare artwork to your collection.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-sm-6">
                                    <div className="choose-item-two wow fadeInUp" data-wow-delay=".4s">
                                        <div className="choose-icon-two">
                                            <img src="assets/img/icon/h2_choose_icon02.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Lifetime free transaction</a></h2>
                                            <p>Add new, trending and rare artwork to your collection.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-sm-6">
                                    <div className="choose-item-two wow fadeInUp" data-wow-delay=".6s">
                                        <div className="choose-icon-two">
                                            <img src="assets/img/icon/h2_choose_icon03.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Protect the identity</a></h2>
                                            <p>Add new, trending and rare artwork to your collection.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-sm-6">
                                    <div className="choose-item-two wow fadeInUp" data-wow-delay=".8s">
                                        <div className="choose-icon-two">
                                            <img src="assets/img/icon/h2_choose_icon04.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Sercurity &amp; control over money</a></h2>
                                            <p>Add new, trending and rare artwork to your collection.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* choose-area-end */}
                    {/* counter-area */}
                    <section className="counter-area">
                        <div className="container custom-container-four">
                            <div className="counter-inner">
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-sm-6">
                                        <div className="counter-item">
                                            <div className="counter-icon">
                                                <img src="assets/img/icon/counter_icon01.svg" alt />
                                            </div>
                                            <div className="counter-content">
                                                <h2 className="count"><span className="odometer" data-count={280} />K</h2>
                                                <p>Active Installation</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-6">
                                        <div className="counter-item">
                                            <div className="counter-icon">
                                                <img src="assets/img/icon/counter_icon01.svg" alt />
                                            </div>
                                            <div className="counter-content">
                                                <h2 className="count"><span className="odometer" data-count={250} />K</h2>
                                                <p>Active Installation</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-6">
                                        <div className="counter-item">
                                            <div className="counter-icon">
                                                <img src="assets/img/icon/counter_icon01.svg" alt />
                                            </div>
                                            <div className="counter-content">
                                                <h2 className="count"><span className="odometer" data-count={230} />K</h2>
                                                <p>Active Installation</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* counter-area-end */}
                    {/* roadmap-area */}
                    <section id="roadmap" className="roadmap-area-two pt-130 pb-100">
                        <div className="container custom-container-two">
                            <div className="row justify-content-center">
                                <div className="col-xl-6">
                                    <div className="section-title section-title-two text-center mb-65">
                                        <span className="sub-title">roadmap</span>
                                        <h2 className="title">Bigtech Strategy and <br /> Project Plan</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="roadmap-wrap-two">
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">Mid of Q4 2021</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">Concept</h4>
                                                <p>EVM support for parachains SubQuery Academy Proof of indexing</p>
                                            </div>
                                        </div>
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">Mid Q1 2023</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">App beta test</h4>
                                                <p>Public testnet launch <br /> SubQuery Network Explorer and dApp <br /> Point-in-time indexing</p>
                                            </div>
                                        </div>
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">Mid Q2 2023</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">Alpha test</h4>
                                                <p>Launch of the SubQuery Foundation Finalise research for other Layer-1 chains Liquidity mining program</p>
                                            </div>
                                        </div>
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">End of Q2 2023</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">Operational</h4>
                                                <p>SubQuery launches its own parachainSubQuery Foundation</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="roadmap-wrap-two bottom">
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">Mid of Q4 2024</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">Concept</h4>
                                                <p>EVM support for parachains SubQuery Academy Proof of indexing</p>
                                            </div>
                                        </div>
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">Mid Q1 2025</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">App beta test</h4>
                                                <p>Public testnet launch <br /> SubQuery Network Explorer and dApp <br /> Point-in-time indexing</p>
                                            </div>
                                        </div>
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">Mid Q2 2026</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">Alpha test</h4>
                                                <p>Launch of the SubQuery Foundation Finalise research for other Layer-1 chains Liquidity mining program</p>
                                            </div>
                                        </div>
                                        <div className="roadmap-item">
                                            <span className="roadmap-title">End of Q2 2030</span>
                                            <div className="roadmap-content">
                                                <span className="dot" />
                                                <h4 className="title">Operational</h4>
                                                <p>SubQuery launches its own parachainSubQuery Foundation</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* roadmap-area-end */}
                    {/* team-area */}
                    <section className="team-area-two team-bg">
                        <div className="container custom-container-four">
                            <div className="row justify-content-center">
                                <div className="col-lg-6">
                                    <div className="section-title text-center mb-60">
                                        <span className="sub-title">OUr team</span>
                                        <h2 className="title">The Leadership <br /> <span>Team</span></h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="team-item team-item-two wow fadeInUp" data-wow-delay=".2s">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/h2_team_img01.png" alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Cameron Williamson</h2>
                                            <span>Founder &amp; CO</span>
                                            <ul className="team-social">
                                                <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                                <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                                                <li><a href="#"><i className="fab fa-instagram" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="team-item team-item-two wow fadeInUp" data-wow-delay=".4s">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/h2_team_img02.png" alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Eleanor Pena</h2>
                                            <span>Head of Design</span>
                                            <ul className="team-social">
                                                <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                                <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                                                <li><a href="#"><i className="fab fa-instagram" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="team-item team-item-two wow fadeInUp" data-wow-delay=".6s">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/h2_team_img03.png" alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Bessie Cooper</h2>
                                            <span>Vp People</span>
                                            <ul className="team-social">
                                                <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                                <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                                                <li><a href="#"><i className="fab fa-instagram" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="team-item team-item-two wow fadeInUp" data-wow-delay=".8s">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/h2_team_img04.png" alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Darlene Robertson</h2>
                                            <span>Product Manager</span>
                                            <ul className="team-social">
                                                <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                                <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                                                <li><a href="#"><i className="fab fa-instagram" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* team-area-end */}
                    {/* download-area */}
                    <section className="download-area pt-150 pb-140">
                        <div className="container custom-container-four">
                            <div className="row align-items-center">
                                <div className="col-xl-7 col-lg-6 order-0 order-lg-2">
                                    <div className="download-img text-center wow fadeInRight" data-wow-delay=".2s">
                                        <img src="assets/img/images/download_img.png" alt />
                                    </div>
                                </div>
                                <div className="col-xl-5 col-lg-6">
                                    <div className="download-content wow fadeInLeft" data-wow-delay=".2s">
                                        <div className="section-title section-title-two mb-20">
                                            <span className="sub-title">Download ICO App</span>
                                            <h2 className="title">You can treding, control, buy and sell from your mobile</h2>
                                        </div>
                                        <p>The World’s 1st ICO Platform That Offers Rewards and The platform helps investors to make easy</p>
                                        <div className="download-btn">
                                            <a href="#"><img src="assets/img/images/download_btn01.png" alt /></a>
                                            <a href="#"><img src="assets/img/images/download_btn02.png" alt /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* download-area-end */}
                    {/* faq-area */}
                    <section id="faq" className="faq-area">
                        <div className="container custom-container-four">
                            <div className="faq-shape-wrap">
                                <img src="assets/img/images/faq_shape01.png" alt className="img-one" />
                                <img src="assets/img/images/faq_shape02.png" alt className="img-two rotateme" />
                                <img src="assets/img/images/faq_shape03.png" alt className="img-three" />
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title section-title-two text-center mb-60">
                                        <h2 className="title">Frequently asked questions</h2>
                                    </div>
                                    <div className="faq-wrap wow fadeInUp" data-wow-delay=".2s">
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        Do I need to install any software?
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingTwo">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        Is my data safe?
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        How does the 30-day free software trial work?
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingFour">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                        How does the 30-day free software trial work?
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingFive">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                        How does the 30-day free software trial work?
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* faq-area-end */}
                    {/* contact-area */}
                    <section id="contact" className="contact-aera contact-bg">
                        <div className="container custom-container-four">
                            <div className="contact-inner">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="contact-info-wrap-two wow fadeInLeft" data-wow-delay=".2s">
                                            <h2 className="title">Get in Touch</h2>
                                            <div className="contact-list-item">
                                                <div className="icon">
                                                    <img src="assets/img/icon/contact_icon01.svg" alt />
                                                </div>
                                                <div className="content">
                                                    <p>Chevy Chase, Maryland 20815 Wisconsin Ave, Suite 700</p>
                                                </div>
                                            </div>
                                            <div className="contact-list-item">
                                                <div className="icon">
                                                    <img src="assets/img/icon/contact_icon01.svg" alt />
                                                </div>
                                                <div className="content">
                                                    <p>support@figma.com</p>
                                                </div>
                                            </div>
                                            <div className="contact-list-item">
                                                <div className="icon">
                                                    <img src="assets/img/icon/contact_icon01.svg" alt />
                                                </div>
                                                <div className="content">
                                                    <p>088 (778 886 664)</p>
                                                </div>
                                            </div>
                                            <div className="contact-list-item">
                                                <div className="icon">
                                                    <img src="assets/img/icon/contact_icon01.svg" alt />
                                                </div>
                                                <div className="content">
                                                    <p>088 (778 886 664)</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="contact-form-wrap-two wow fadeInRight" data-wow-delay=".2s">
                                            <h2 className="title">Lets Get in touch with us</h2>
                                            <form action="#">
                                                <input type="text" placeholder="Name" required />
                                                <input type="email" placeholder="Email Address" required />
                                                <textarea name="massage" placeholder="Massage" required defaultValue={""} />
                                                <button type="submit" className="btn btn-two">Send Massage</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* contact-area-end */}
                    {/* newsletter-area */}
                    <section className="newsletter-area">
                        <div className="container custom-container-four">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="newsletter-wrap">
                                        <div className="newsletter-content">
                                            <h2 className="title">Subscribe Newsletters</h2>
                                        </div>
                                        <div className="newsletter-form">
                                            <form action="#">
                                                <input type="text" placeholder="Enter your email" required />
                                                <button type="submit" className="btn btn-two">Subscribe</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* newsletter-area-end */}
                </main>
                {/* main-area-end */}
                {/* footer-area */}
                <footer>
                    <div className="footer-area-two">
                        <div className="container custom-container-four">
                            <div className="footer-top">
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="footer-menu-two">
                                            <ul className="navigation">
                                                <li><a href="#">About us</a></li>
                                                <li><a href="#">Roadmap</a></li>
                                                <li><a href="#">Blog</a></li>
                                                <li><a href="#">Career</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="footer-social">
                                            <ul>
                                                <li><a href="#"><i className="fab fa-facebook-square" /></a></li>
                                                <li><a href="#"><i className="fab fa-twitter" /></a></li>
                                                <li><a href="#"><i className="fab fa-vimeo-v" /></a></li>
                                                <li><a href="#"><i className="fab fa-youtube" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-bottom">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <div className="copyright-text">
                                            <p>Copyright © 2023. All Rights Reserved Bigtech</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="scroll-up text-center">
                                            <button className="scroll-to-target" data-target="html"><i className="fas fa-arrow-up" /></button>
                                            <span>scroll Top</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div className="footer-bottom-menu">
                                            <ul>
                                                <li><a href="#">Terms of Service</a></li>
                                                <li><a href="#">Privacy Policy</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/* footer-area-end */}
            </div>
        </>
    )
}

export default Index1